import { useRef, useState } from 'react';
import { IConfirmSettings } from '../components/types';
import { DefaultConfirm } from '../components';

let promise: {
  resolve: (value: string) => void;
  reject: (reason?: string) => void;
} | null = null;

const defaultConfirmSettings: IConfirmSettings = {
  title: 'Подтверждение',
  body: '',
  type: 'confirm',
  confirmText: 'Да',
  dismissText: 'Нет',
};

export const useConfirm = () => {
  const [show, setShow] = useState<boolean>(false);
  const [settings, setSettings] = useState<IConfirmSettings>({
    ...defaultConfirmSettings,
  });

  const handleShow = (confirmSettings: IConfirmSettings): Promise<string> => {
    setSettings({ ...defaultConfirmSettings, ...confirmSettings });
    setShow(true);

    return new Promise<string>((resolve, reject) => {
      promise = { resolve, reject };
    });
  };

  const handleConfirm = () => {
    promise?.resolve('');
    setShow(false);
  };

  const handleDismiss = () => {
    promise?.reject();
    setShow(false);
  };

  // stateRef синхронизируется каждый рендер, чтобы Component всегда читал актуальные значения.
  // Component создаётся один раз — стабильная ссылка нужна, чтобы React не пересоздавал дерево.
  const stateRef = useRef({ show, settings, handleConfirm, handleDismiss });
  stateRef.current = { show, settings, handleConfirm, handleDismiss };

  const Component = useRef(() => {
    const { show, settings, handleConfirm, handleDismiss } = stateRef.current;

    return (
      <DefaultConfirm
        {...settings}
        show={show}
        onConfirm={handleConfirm}
        onDismiss={handleDismiss}
      />
    );
  }).current;

  return [Component, handleShow] as const;
};
